module.exports = __webpack_public_path__ + "media/images/people-c05c718f0393940b105f9b43a3717abc.svg";